import LegalLayout from "@/components/LegalLayout";
import { Mail, Instagram, MessageCircle } from "lucide-react";

export default function Contact() {
  return (
    <LegalLayout title="Nous contacter" updated={null}>
      <div data-testid="contact-page">
        <p className="!text-base">
          Une question, un bug, une suggestion pour améliorer Ma Petite Yole ? On adore les
          retours de la communauté — n'hésite pas à nous écrire.
        </p>

        <div className="not-prose grid gap-4 sm:grid-cols-2 mt-8">
          <a
            href="mailto:contact@mapetiteyole.com"
            data-testid="contact-email-link"
            className="group flex items-start gap-4 p-5 rounded-2xl border-2 border-slate-200 bg-white hover:border-[color:var(--coral)] hover:shadow-md transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-[color:var(--coral)]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[color:var(--coral)] group-hover:text-white transition-colors">
              <Mail className="h-6 w-6 text-[color:var(--coral)] group-hover:text-white" />
            </div>
            <div className="min-w-0">
              <div className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-0.5">Email</div>
              <div className="font-bold text-[color:var(--deep)] text-base">contact@mapetiteyole.com</div>
              <div className="text-xs text-slate-500 mt-1">Réponse sous 48h ouvrées</div>
            </div>
          </a>

          <a
            href="https://instagram.com/ma_petite_yole"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-instagram-link"
            className="group flex items-start gap-4 p-5 rounded-2xl border-2 border-slate-200 bg-white hover:border-[color:var(--sunshine)] hover:shadow-md transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] flex items-center justify-center flex-shrink-0">
              <Instagram className="h-6 w-6 text-white" />
            </div>
            <div className="min-w-0">
              <div className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-0.5">Instagram</div>
              <div className="font-bold text-[color:var(--deep)] text-base">@ma_petite_yole</div>
              <div className="text-xs text-slate-500 mt-1">Suis nous pour les mises à jour</div>
            </div>
          </a>
        </div>

        <h2>Ce sur quoi on peut t'aider</h2>
        <ul>
          <li><strong>Un souci de compte</strong> — mot de passe oublié, impossible de se connecter.</li>
          <li><strong>Une question sur les ligues</strong> — code invalide, transfert de ligue, etc.</li>
          <li><strong>Un désaccord sur un classement</strong> — erreur d'attribution de points, dessalage manquant.</li>
          <li><strong>Signaler un bug</strong> — décris l'écran, l'appareil et l'action que tu réalisais.</li>
          <li><strong>Demande RGPD</strong> — accès, rectification ou suppression de tes données personnelles.</li>
        </ul>

        <h2>Réseaux sociaux</h2>
        <p>
          Retrouve toute l'actu de Ma Petite Yole sur Instagram{" "}
          <a href="https://instagram.com/ma_petite_yole" target="_blank" rel="noopener noreferrer">
            @ma_petite_yole
          </a>{" "}
          : résultats d'étape, portraits de yoles, meilleurs pronostiqueurs de la semaine.
        </p>

        <div className="not-prose mt-8 rounded-2xl bg-[color:var(--deep)] text-white p-6">
          <div className="flex items-start gap-3">
            <MessageCircle className="h-6 w-6 text-[color:var(--sunshine)] flex-shrink-0 mt-0.5" />
            <div>
              <div className="brand-wordmark text-xl text-[color:var(--sunshine)]">Un mot avant tout</div>
              <p className="text-sm opacity-90 mt-1 !text-white">
                Ma Petite Yole est une aventure entre amis, portée par des passionnés du Tour.
                Sois patient·e, on répond dès qu'on peut — souvent le soir ou le week-end.
              </p>
            </div>
          </div>
        </div>
      </div>
    </LegalLayout>
  );
}
